import {ajax} from './ajax'

//授课计划
//1、获取授课计划分页
export const reqPlanList = (paramets) => ajax(`/jxplan/jxPlan/getPlanPageList`, paramets)

//2、添加授课计划
export const reqAddPlan = (paramets) => ajax(`/jxplan/jxPlan/add`, paramets, 'post')

//3、修改授课计划
export const reqUpdatePlan = (paramets) => ajax(`/jxplan/jxPlan/edit`, paramets, 'put')

//4、获取班级树列表
export const reqCourseTreeList = (paraments) => ajax("/jxclass/jxClassByBasic/getTreeList", paraments)

//4、获取教师树列表
export const reqTeamsTreeList = (paraments) => ajax("/jxclass/jxClassByBasic/getUserTreeList", paraments)

//5、获取全部专业信息
export const reqMajorList = () => ajax("/school/majorInfo/queryList")

//7、通过专业获取教师
export const reqTeamListByMajorId = (paraments) => ajax("/sys/user/userListByMajorId", paraments)

//8、通过id查询授课计划
export const reqPlanById = (paraments) => ajax("/jxplan/jxPlan/queryById", paraments)

//8、通过id查询授课计划关联目录
export const reqPlanCatalogById = (paraments) => ajax("/jxplan/jxPlan/queryJxPlanCatalogByMainId", paraments)

//8、通过id查询授课计划关联班级
export const reqPlanClassById = (paraments) => ajax("/jxplan/jxPlan/queryJxPlanClassByMainId", paraments)

//8、通过id查询授课计划关联团队
export const reqPlanTeamById = (paraments) => ajax("/jxplan/jxPlan/queryJxPlanTeacherByMainId", paraments)

//8、通过id删除授课计划
export const reqDeleteById = (paraments) => ajax("/jxplan/jxPlan/delete", paraments,'delete')

// 添加到行政班级
export const reqAddXzClass = (paraments) => ajax("/jxclass/jxClass/addBC", paraments, 'post')

// 查看--获取课程目录
export const reqViewCourseTree = (paraments) => ajax("/jxplan/jxPlan/getCatalogByCourse", paraments)
